import { useSyncExternalStore } from 'react'

interface ForecastSourceState {
  source: 'demo' | 'live'
  locationId: string | null
}

let state: ForecastSourceState = { source: 'demo', locationId: null }

let forecastSourceVersion = 0
const listeners = new Set<() => void>()

const emit = () => {
  forecastSourceVersion += 1
  listeners.forEach((listener) => listener())
}

export function getForecastSource(): 'demo' | 'live' {
  return state.source
}

export function getForecastLocationId(): string | null {
  return state.locationId
}

export function setForecastSource(source: 'demo' | 'live'): void {
  if (state.source === source) return
  state = { ...state, source }
  emit()
}

export function setForecastLocationId(id: string | null): void {
  if (state.locationId === id) return
  state = { ...state, locationId: id }
  emit()
}

const subscribe = (listener: () => void) => {
  listeners.add(listener)
  return () => listeners.delete(listener)
}

const getSnapshot = () => forecastSourceVersion

export function useForecastSourceVersion(): number {
  return useSyncExternalStore(subscribe, getSnapshot, getSnapshot)
}
